// src/data/transducersData.js - Contains all transducer product data

export const transducersData = [
  {
    id: "livescope-plus-lvs34",
    name: "LiveScope Plus LVS34",
    type: "livescope",
    msrp: 1699.99,
    powerDraw12V: "1.7",
    peakPowerDraw: "4.8 A",
    sonarFrequency: "530–1100 kHz",
    image: "/images/transducers/livescopeplus.jpg",
    fallbackImage: "/images/transducers/livescopeplus.jpg",
    description: `Best All-Around | Most Popular | Top Clarity\nThe gold standard for real-time sonar. Incredible clarity and separation make it ideal for most fishing styles.\n✅ Great for seeing fish and structure clearly at typical freshwater depths.\n✅ Best balance of detail, performance, and versatility.`,
    notes: "Ideal for anglers wanting the clearest possible live imaging with excellent detail at moderate ranges. Best all-around live imaging option for most fishing situations.",
    maxRange: "200 ft",
    maxRangeSaltwater: "~170 ft",
    targetSeparation: "~14″ at 100 ft",
    beamAngle: "20° x 135° field of view",
    blackBoxRequired: true,
    blackBoxModel: "GLS 10 module",
    dimensions: "6.4″ × 3.1″ × 1.9″",
    releaseYear: "2022",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, with perspective mount option"
  },
  {
    id: "livescope-xr-lvs62",
    name: "LiveScope XR LVS62",
    type: "livescope",
    msrp: 2499.99,
    powerDraw12V: "1.7",
    peakPowerDraw: "4.8 A",
    sonarFrequency: "265–550 kHz",
    image: "https://www.russellmarineproducts.com/media/catalog/product/cache/9e8d382f4b78775fd20b092f31a2f0d1/8/2/82671090.jpg",
    fallbackImage: "https://www.russellmarineproducts.com/media/catalog/product/cache/9e8d382f4b78775fd20b092f31a2f0d1/8/2/82671090.jpg",
    description: "Extended Range LiveScope designed specifically for deep/open water applications, with range capabilities more than double standard LiveScope.",
    notes: "The ultimate choice for offshore and deep water fishing where maximum range is critical. Great for finding structure and fish in deeper waters or locating schools at greater distances.",
    maxRange: "500 ft",
    maxRangeSaltwater: "~350 ft",
    targetSeparation: "~22″ at 100 ft",
    beamAngle: "20° x ~135° (narrow beam)",
    blackBoxRequired: true,
    blackBoxModel: "GLS 10 module",
    dimensions: "8.2″ × 4.0″ × 2.8″",
    releaseYear: "2022",
    imagingModes: "Forward, Down, Perspective",
    mountingIncluded: "Yes, with perspective mount option"
  },
  {
    id: "panoptix-ps22",
    name: "Panoptix PS22",
    type: "livescope",
    msrp: 999.99,
    powerDraw12V: "0.7",
    peakPowerDraw: "4.0 A (fused)",
    sonarFrequency: "417 kHz",
    image: "https://res.garmin.com/transform/image/upload/b_rgb:FFFFFF,c_pad,dpr_2.0,f_auto,h_400,q_auto,w_400/c_pad,h_400,w_400/v1/Product_Images/en/products/010-01945-00/g/cf-lg?pgw=1",
    fallbackImage: "https://res.garmin.com/transform/image/upload/b_rgb:FFFFFF,c_pad,dpr_2.0,f_auto,h_400,q_auto,w_400/c_pad,h_400,w_400/v1/Product_Images/en/products/010-01945-00/g/cf-lg?pgw=1",
    description: "Versatile live-scanning sonar that offers both forward and downward views with a simple one-knob adjustment - a great entry point to live sonar technology.",
    notes: "More affordable than LiveScope with simplified installation (no black box required). Perfect for trolling motor mounting and ideal for anglers who want real-time fish tracking without complex setup.",
    maxRange: "100 ft (forward), 300 ft (down)",
    maxRangeSaltwater: "~80 ft (forward), ~240 ft (down)",
    targetSeparation: "Good but lower than LiveScope",
    beamAngle: "20° x 100° field of view",
    blackBoxRequired: false,
    dimensions: "1.3″ × 4.6″ × 3.8″",
    releaseYear: "2017",
    imagingModes: "Forward, Down (LiveVü)",
    mountingOption: "Trolling motor (shaft or head)",
    mountingIncluded: "Yes, trolling motor mount with pivot"
  },
  {
    id: "panoptix-ps31-forward",
    name: "Panoptix PS31 Forward",
    type: "livescope",
    msrp: 1499.99,
    powerDraw12V: "0.8",
    sonarFrequency: "~417 kHz",
    image: "https://defender.com/media/catalog/product/cache/3106cf6870ef61da8313fd82d69c8643/catalogimages/garmin/panoptix-ps31-forward-transducer-010-01284-01--2.jpg",
    fallbackImage: "https://defender.com/media/catalog/product/cache/3106cf6870ef61da8313fd82d69c8643/catalogimages/garmin/panoptix-ps31-forward-transducer-010-01284-01--2.jpg",
    description: "First-generation forward-looking sonar that provides both 2D LiveVü and 3D RealVü views of the water ahead of your boat.",
    notes: "Budget-friendly option for seeing structure ahead with lower power draw. Connects directly to compatible displays without additional black box required.",
    maxRange: "300 ft",
    maxRangeSaltwater: "~240 ft",
    targetSeparation: "Coarser resolution vs. LiveScope",
    beamAngle: "~20° x 120° (forward fan)",
    blackBoxRequired: false,
    dimensions: "6.7″ × 3.6″ × 1.7″",
    releaseYear: "2015",
    imagingModes: "Forward (live & 3D modes)",
    mountingIncluded: "Yes, through-hull or transom mount"
  },
  {
    id: "panoptix-ps30-down",
    name: "Panoptix PS30 Down",
    type: "livescope",
    msrp: 1499.99,
    powerDraw12V: "0.8",
    sonarFrequency: "~417 kHz",
    image: "https://res.garmin.com/en/products/010-01284-00/g/cf-lg.jpg",
    fallbackImage: "https://res.garmin.com/en/products/010-01284-00/g/cf-lg.jpg",
    description: "Down-looking sonar with 360° coverage that shows a real-time view of fish and structure passing beneath your boat.",
    notes: "Great for stationary fishing and scanning directly below. Lower power consumption than LiveScope systems and no black box required for simpler installation.",
    maxRange: "300 ft",
    maxRangeSaltwater: "~240 ft",
    targetSeparation: "Coarser resolution",
    beamAngle: "~90° vertical, 180° wide under boat",
    blackBoxRequired: false,
    dimensions: "~6.7″ × 3.6″ × 1.7″",
    releaseYear: "2015",
    imagingModes: "Down (live & 3D modes)",
    mountingIncluded: "Yes, through-hull mount"
  },
  {
    id: "gt54uhd-chirp",
    name: "GT54UHD CHIRP",
    type: "openWater",
    msrp: 299.99,
    powerDraw12V: "0.25-0.4",
    image: "https://m.media-amazon.com/images/I/41ed8S3fOxL._AC_UF894,1000_QL80_.jpg",
    fallbackImage: "https://m.media-amazon.com/images/I/41ed8S3fOxL._AC_UF894,1000_QL80_.jpg",
    description: "High-definition CHIRP sonar for open water",
    notes: "Great for deep water fishing"
  },
  {
    id: "gt56uhd-chirp",
    name: "GT56UHD CHIRP",
    type: "openWater",
    msrp: 399.99,
    powerDraw12V: "0.3-0.5",
    image: "https://m.media-amazon.com/images/I/514FypkdrUL._AC_UF894,1000_QL80_.jpg",
    fallbackImage: "https://m.media-amazon.com/images/I/514FypkdrUL._AC_UF894,1000_QL80_.jpg",
    description: "Premium CHIRP sonar with wider coverage",
    notes: "Excellent for scanning larger areas"
  },
  {
    id: "gt10hn-if",
    name: "GT10HN-IF",
    type: "iceFisher",
    msrp: 149.99,
    powerDraw12V: "0.2-0.3",
    image: "https://assets.basspro.com/image/list/fn_select:jq:first(.%5B%5D%7Cselect(.public_id%20%7C%20endswith(%22main%22)))/4934670.json?$Prod_PLPThumb$",
    fallbackImage: "https://assets.basspro.com/image/list/fn_select:jq:first(.%5B%5D%7Cselect(.public_id%20%7C%20endswith(%22main%22)))/4934670.json?$Prod_PLPThumb$",
    description: "Compact ice fishing transducer",
    notes: "Perfect for ice fishing in shallow to medium depths"
  },
  {
    id: "gt8hw-if",
    name: "GT8HW-IF",
    type: "iceFisher",
    msrp: 129.99,
    powerDraw12V: "0.15-0.25",
    image: "https://m.media-amazon.com/images/I/312QI4HMkkL._AC_UF894,1000_QL80_.jpg",
    fallbackImage: "https://m.media-amazon.com/images/I/312QI4HMkkL._AC_UF894,1000_QL80_.jpg",
    description: "Wide-beam ice fishing transducer",
    notes: "Great for locating fish in a wider area under the ice"
  }
  // Add more transducers as needed
];